import { useEffect, useState } from 'react';
import { overlayNavMediaQuery } from '../utils/adminNavShell';

function readOverlayMatch() {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia(overlayNavMediaQuery()).matches;
}

/** Vrai sur mobile et sur tablette tactile : le menu est un panneau superposé. */
export function useAdminNavOverlay() {
  const [overlay, setOverlay] = useState(readOverlayMatch);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;
    const media = window.matchMedia(overlayNavMediaQuery());
    const sync = () => setOverlay(media.matches);
    sync();
    media.addEventListener('change', sync);
    return () => media.removeEventListener('change', sync);
  }, []);

  return overlay;
}
